import React from 'react'

const ContentArea = ({ children }) => <main className="page-main main-anim scrollpage-container "
                                            id="mainpage">{children}</main>

export default ContentArea
